import { useToggler } from '@cbhq/cds-common/hooks/useToggler';
import { BoxBackgroundProps } from '@cbhq/cds-common/types/BoxBaseProps';
import { IconButton } from '@cbhq/cds-web/buttons';
import { VStack } from '@cbhq/cds-web/layout';
import { Box } from '@cbhq/cds-web/layout/Box';
import { HStack } from '@cbhq/cds-web/layout/HStack';
import { Tooltip } from '@cbhq/cds-web/overlays/Tooltip/Tooltip';
import { TextBody } from '@cbhq/cds-web/typography';
import { TextLabel1 } from '@cbhq/cds-web/typography/TextLabel1';

import { ClipboardIcon } from ':cloud/widgets/sharedcomponents';

interface AuthFieldProps {
  label?: string;
  code: string;
  codeToCopy?: string;
  isPassword?: boolean;
  testID?: string;
  maxWidth?: number;

  background?: BoxBackgroundProps['background'];
}

export function AuthField({
  label,
  code,
  codeToCopy,
  isPassword = false,
  testID,
  maxWidth,
  background = 'primaryWash',
}: AuthFieldProps) {
  const [tokenPasswordVisible, { toggle: toggleTokenPassword }] = useToggler(false);
  const maskedCode = ''.padEnd(code.length, tokenPasswordVisible ? code : '*');
  return (
    <VStack gap={isPassword ? 0.5 : 1}>
      {label && <TextLabel1 as="p">{label}</TextLabel1>}
      <HStack alignItems="center" gap={1}>
        <Box
          background={background}
          spacing={0.5}
          borderRadius="roundedSmall"
          width="fit-content"
          maxWidth={maxWidth}
          overflow="auto"
        >
          <TextBody color="foregroundMuted" as="div">
            <code data-testid={testID}>
              {isPassword && !tokenPasswordVisible ? maskedCode : code}
            </code>
          </TextBody>
        </Box>
        <HStack alignItems="center">
          {isPassword && (
            <Tooltip content={tokenPasswordVisible ? 'Hide' : 'Show'}>
              <IconButton
                compact={false}
                name={tokenPasswordVisible ? 'visibleInactive' : 'visibleActive'}
                onPress={toggleTokenPassword}
                transparent
                testID="trigger-password-button1111"
              />
            </Tooltip>
          )}
          <ClipboardIcon text={codeToCopy || code} />
        </HStack>
      </HStack>
    </VStack>
  );
}
